import { combineReducers } from 'redux';
import auth from './auth';
import alerts from './alerts';
import responsive from './responsive';

const rootReducer = combineReducers({
  auth,
  alerts,
  responsive,
});

export default rootReducer;
